import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {TableModule} from 'primeng/table';
import {InputTextModule} from 'primeng/inputtext';
import {ListboxModule} from 'primeng/listbox';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {PanelModule} from 'primeng/panel';
import {ChartModule} from 'primeng/chart';
import {SharedDocumalisModule} from './../documalis/shared-documalis.module';
import {ContextMenuModule} from 'primeng/contextmenu';
import {InputSwitchModule} from 'primeng/inputswitch';
import {NgxUploadModule, MineTypeEnum, DropTargetOptions} from '@wkoza/ngx-upload';
import {ProgressBarModule} from 'primeng/progressbar';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {TreeModule} from 'primeng/tree';
import {FieldsetModule} from 'primeng/fieldset';
import {InputNumberModule} from 'primeng/inputnumber';
import {RippleModule} from "primeng/ripple";
import {BlockUIModule} from "primeng/blockui";
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import {ImageGalleryComponent} from "../documalis/images";

export const ngxDropTargetOptions: DropTargetOptions = {
    color: 'dropZoneColor',
    colorDrag: 'dropZoneColorDrag',
    colorDrop: 'dropZoneColorDrop',
    multiple: false,
    accept: [MineTypeEnum.Image],
};

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        DropdownModule,
        ButtonModule,
        DialogModule,
        TableModule,
        InputNumberModule,
        InputTextModule,
        ListboxModule,
        CalendarModule,
        CheckboxModule,
        PanelModule,
        ChartModule,
        SharedDocumalisModule,
        ContextMenuModule,
        InputSwitchModule,
        NgxUploadModule.forRoot(ngxDropTargetOptions),
        ProgressBarModule,
        NgxExtendedPdfViewerModule,
        TreeModule,
        FieldsetModule,
        RippleModule,
        BlockUIModule,
        InputTextareaModule,
        FileUploadModule,
        ToastModule,
        ImageGalleryComponent,

        /* or CommonModule */
    ],
    declarations: [
    ],
    providers: [SharedDocumalisModule],
    exports: [FileUploadModule, InputTextareaModule],
})
export class CustomModule {
}
